<div class="wrapper">
  @if (showHeaderInfo) {
    <sc-header-info [userInfo]="userInfo"></sc-header-info>
  }
  @if (showHeader) {
    <header [class.with-header-info]="showHeaderInfo">
      <sc-header></sc-header>
    </header>
  }
  <main [ngClass]="{'main-admin': userInfo.userRole === 'Administrador'}">
    <router-outlet (activate)="updateHeaderVisibility()"></router-outlet>
  </main>
  @if (showFooter) {
    <footer>
      <sc-footer></sc-footer>
    </footer>
  }
  <sc-versions-modal></sc-versions-modal>
</div>